import { useContext } from 'react'
import { CharlyChatContext } from '../CharlyChat'

function ModelCao () {
  const { selectCaoOption } = useContext(CharlyChatContext)

  return (
    <form>
        <div className='form-row'>
            <h6>Kies een optie om verder te gaan naar Charly.</h6>
        </div>
        <div className='form-row'>
            <div className='d-flex gap-2 my-3'>
            <button
                className='btn secondary flex-fill'
                onClick={() => selectCaoOption('Service center')}
            >
                Service center
            </button>
            <button
                className='btn secondary flex-fill'
                onClick={() => selectCaoOption('Winkel')}
            >
                Winkel
            </button>
            </div>
        </div>
    </form>

  )
}

export default ModelCao
